import { Pipe, PipeTransform } from '@angular/core'
import { MaterialComponent } from '../../domain/orders/work-items/bom/material-component'
import { Quantity } from '@elderbyte/ngx-starter'

@Pipe({
  name: 'productSalesTotalWeight',
})
export class ProductSalesTotalWeightPipe implements PipeTransform {
  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public transform(component: MaterialComponent, ...args: unknown[]): Quantity | null {
    return MaterialComponent.getWeight(component)
  }
}
